import React, {useState} from 'react';
import './RecoveryPass.scss';
import { validateErrorPassword, recoveryUserPassForm, 
    closeRecoveryPassForm, clearErrorMessages, openLoginForm } from '../authSlice';
import { useNavigate } from "react-router-dom";




import  {validatePassword}  from '../../../helper/validation';

const RecoveryPass = (props) => {

    const {dispatch} = props;



    const [userInputPassword, setUserInputPassword]= useState('');
    const [userInputPasswordRepeat, setUserInputPasswordRepeat]= useState('');
    const [errorValidation, setErrorValidation] = useState('');
    const [errorValidationRepeat, setErrorValidationRepeat] = useState('');
       
    const navigate = useNavigate();



    //CLICK SEND EMAIL
    const onSend = () => {
/*
            const getCookie = (name) =>{
    let cookie = document.cookie.split('; ').find(row => row.startsWith(name + '='));
    return cookie ? cookie.split('=')[1] : null;
    }
*/
     //const urlToken = getCookie("urlTokenPass");
    //const urlToken = document.cookie;


       

    if (userInputPassword !== userInputPasswordRepeat)  {

     setErrorValidationRepeat('Пароли не совпадают');
     
    } else {

        const item = {
         userPassword: userInputPassword,
        }


        console.log("ok! send new pass recovery");

       // const urlToken = document.cookie
       // console.log(urlToken);
       dispatch(recoveryUserPassForm(item)).unwrap()
        .then((res) => {




            
            console.log("RES" + " " + res);
            navigate('/');
        
        })
     
       //return <Navigate to="/" />
        
         //  dispatch(closeRecoveryPassForm());
         //  dispatch(openLoginForm());
    }; 
        

    }


    // HANDLE EMAIL

    const handleUserInputPassword = (e) => {
        
        const message = validatePassword(e.target.value);
        dispatch(validateErrorPassword(message));
        dispatch(clearErrorMessages());
        
        
        setUserInputPassword(e.target.value);
        setErrorValidation(message);
    
    }
    // HANDLE EMAIL REPEAT

    const handleUserInputPasswordRepeat = (e) => {
        console.log(e.target.value);
        setUserInputPasswordRepeat(e.target.value);
        
    

    }
        // CLEAR FORM

    const onClearForm = () => {
        
    setUserInputPassword('');
    setUserInputPasswordRepeat('');
    setErrorValidation('');
    setErrorValidationRepeat('');
        
    }

    
    






  
    let style;
        
    if ( !props.userData.errorMessagePassword
        && userInputPassword && userInputPasswordRepeat) {
      
            style = ''
        } else {
            style = 'disabled'
    }

        return (
            <div className="RecoveryPass">
              <h3>Введите новый пароль</h3>
               <div className='inputBlock'>
                   <input type='password'  placeholder="Пароль" required minLength ="5" 
                        value={userInputPassword} onChange={handleUserInputPassword}/>
                    
                  
               </div>
                <div className='errorBlock'>
                    <p className="error">{errorValidation}</p>
   
                </div>
                <h3> Повторите пароль</h3>
                <div className='inputBlock'>
                        <input type='password'  placeholder="Пароль" required minLength ="5" 
                        value={userInputPasswordRepeat} onChange={handleUserInputPasswordRepeat}/>
                    
                  
                </div>

                <div className='errorBlock'>
                    <p className="error">{errorValidationRepeat}</p>
                    
   
                </div>

                <div className='buttonBlock'>
                    <button className='loginButton' onClick={onSend} disabled={style}>Отправить</button>
                    
                </div>
                
                <div className='buttonBlock'>
                    <button className='loginButton' onClick={onClearForm} disabled={style}>Очистить</button>
                    
                </div>

            </div>
        )
    
}
export default RecoveryPass;
